import { DialogComponent } from '@theme/dialog';

/**
 * A custom element that manages an Algolia search drawer.
 * Extends the base DialogComponent to provide search drawer functionality.
 *
 * @extends {DialogComponent}
 */
class AlgoliaSearchDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    
    // Initialize Algolia search when drawer opens
    this.addEventListener('dialog:opened', this.#handleDrawerOpen);
    this.addEventListener('dialog:closed', this.#handleDrawerClose);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('dialog:opened', this.#handleDrawerOpen);
    this.removeEventListener('dialog:closed', this.#handleDrawerClose);
  }

  /**
   * Handle drawer opening - initialize Algolia search
   */
  #handleDrawerOpen = () => {
    // Focus the search input when drawer opens
    const searchInput = this.querySelector('#algolia-search-input');
    if (searchInput) {
      // Small delay to ensure drawer animation completes
      setTimeout(() => {
        searchInput.focus();
      }, 100);
    }

    // Initialize Algolia search if not already done
    if (window.algoliaPredictiveSearch && !window.algoliaPredictiveSearch.isInitialized) {
      window.algoliaPredictiveSearch.initialize();
    }
  };

  /**
   * Handle drawer closing - cleanup if needed
   */
  #handleDrawerClose = () => {
    // Clear search input when drawer closes
    const searchInput = this.querySelector('#algolia-search-input');
    if (searchInput) {
      searchInput.value = '';
    }

    // Clear Algolia search results
    const resultsContainer = this.querySelector('.algolia-predictive-search-results__wrapper-products');
    if (resultsContainer) {
      resultsContainer.innerHTML = '';
    }

    // Close Algolia autocomplete if open
    if (window.algoliaPredictiveSearch && window.algoliaPredictiveSearch.autocompleteInstance) {
      window.algoliaPredictiveSearch.autocompleteInstance.setQuery('');
      window.algoliaPredictiveSearch.autocompleteInstance.setIsOpen(false);
    }
  };

  /**
   * Open the search drawer
   */
  open() {
    this.showDialog();
  }

  /**
   * Close the search drawer
   */
  close() {
    this.closeDialog();
  }
}

if (!customElements.get('algolia-search-drawer-component')) {
  customElements.define('algolia-search-drawer-component', AlgoliaSearchDrawerComponent);
}
